"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgSupport(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { d: "M17.515 9.568a4.921 4.921 0 011.415 7.343l-.159.19L18.769 20l-2.621-1.348a4.94 4.94 0 01-1.071.117 4.907 4.907 0 01-3.423-1.385 7.384 7.384 0 005.869-7.716l-.008-.1zm-1.306 1.692l-.008.042a6.124 6.124 0 01-.441 1.393l-.058.124a6.126 6.126 0 01-1.284 1.772 6.185 6.185 0 01-2.512 1.464 6.11 6.11 0 01-1.112.22l-.191.017a6.242 6.242 0 01-2.327-.276l-3.045 1.522v-3.692a6.154 6.154 0 1111.038-2.986l-.025.183c-.01.073-.022.145-.035.217z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.default = tombacIcon_1.default('Support')(SvgSupport);
//# sourceMappingURL=Support.js.map